import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('SummaryAlertWrapper')(css({
    borderRadius: '3px',
    py: ['xs', 'xs', 's'],
    px: ['s', 's', 'm'],
    backgroundColor: 'notification.warning',
}));
themeStyles.addBaseStyles('SummaryAlertCopy')(css({
    mt: '2px',
    fontFamily: 'bold',
    alignSelf: 'center',
}));
themeStyles.addBaseStyles('TextCtaWrapper')(css({
    gap: 'm',
    width: '100%',
    display: ['block', 'block', 'flex'],
    justifyContent: 'space-between',
}));
themeStyles.addBaseStyles('SeeChangesCta')(css({
    display: 'flex',
    flexShrink: 0,
    mt: ['xs', 'xs', 'zero'],
}));
themeStyles.addBaseStyles('IconWrapper')(css({
    display: 'flex',
    alignItems: ['start', 'start', 'center'],
    mt: ['xxs', 'xxs', 'zero'],
}));
themeStyles.addBaseStyles('ConfigChangesCategoryHeader')(css({
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'grey.3',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: '8px',
    minHeight: '40px',
    display: 'flex',
    py: '10px',
}));
themeStyles.addBaseStyles('GroupContainer')(css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'default',
}));
themeStyles.addBaseStyles('ConfigChangesItemContainer')(css({
    display: 'flex',
    gap: 'default',
    justifyContent: 'space-between',
    mt: 'xs',
}));
themeStyles.addBaseStyles('ConfigChangesCategoryOptionTitle')(css({
    fontSize: ['14px', '14px', '16px'],
    lineHeight: '26px',
}));
themeStyles.addBaseStyles('ModalDescription')(css({
    fontSize: ['14px', '14px', '16px'],
    lineHeight: ['22px', '22px', '26px'],
    mt: ['0px', '0px', '8px'],
    mb: '8px',
}));
themeStyles.addBaseStyles('ConfigChangesPrice')(css({
    fontSize: ['14px', '14px', '18px'],
    fontFamily: 'bold',
    textAlign: 'right',
    mr: 'xs',
    mt: '3px',
}));
themeStyles.addBaseStyles('ConfigChangesPayment')(css({
    fontSize: ['12px', '12px', '16px'],
    fontFamily: 'bold',
    textAlign: 'right',
    mr: 'xs',
}));
export default themeStyles;
